import React from "react";
import { processStatisticsPercentage, renderStatistics } from "@/modules/statistics";
import { IGameStatisticsClass } from "@/types/StatisticsTypes";

//note: use this.props.langdata to get language information
export default class M10 extends IGameStatisticsClass {
	lefts = ["1,1,1", "1,2,2", "1,1,2", "1,2,1"];

	constructor() {
		super(null);

		this.filtrate = function(history, filter) {
			const total = history.length;
	
			switch (filter) {
				// case "head-tail": 
				// 	let heads = 0, tails = 0;
				// 	history.forEach(item => {
				// 		const angka = item.angka.split(",");
				// 		let head = 0, tail = 0;
	
				// 		for (const a of angka) {
				// 			if (Number(a) === 1)
				// 				++head;
				// 			else ++tail;
				// 		}
						
				// 		if (head > tail)
				// 			heads++;
				// 		else tails++;
				// 	});
	
				// 	this.statisticsArray.top.push(...[
				// 		<div key="m16gst_0" className="sl-roadmap-circle blue-bg">O</div>,
				// 		<div key="m16gst_1" className="sl-roadmap-circle red-bg">E</div>
				// 	]);
					
				// 	this.statisticsArray.bottom.push(...[
				// 		processStatisticsPercentage("m16gsb_0", tails, total),
				// 		processStatisticsPercentage("m16gsb_1", heads, total)
				// 	]);
				// break;
				
				case "left-right":
					let lefts = 0, rights = 0;
					history.forEach(item => {
						const angka = item.angka;
						if (this.lefts.indexOf(angka) >= 0)
							lefts++;
						else rights++;
					});
					
					this.statisticsArray.top.push(...[
						<div key="m16gst_2" className="sl-roadmap-circle red-circle">L</div>,
						<div key="m16gst_3" className="sl-roadmap-circle blue-circle">R</div>
					]);
					
					this.statisticsArray.bottom.push(...[
						processStatisticsPercentage("m16gsb_2", lefts, total),
						processStatisticsPercentage("m16gsb_3", rights, total)
					]);
				break;
				default: break;
			}
		};
	}

	render() {
		return renderStatistics(this);
	}
}
